// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
const triggerBrowserReflow = (node: { offsetHeight: any }) => node.offsetHeight;
export default triggerBrowserReflow;
